export default __webpack_public_path__ + "static/media/bowling-icon.50d9e1ac.svg";